import * as React from "react";

function SvgComponent(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.063 9.808a3.654 3.654 0 100-7.308 3.654 3.654 0 000 7.308zm0-6.154a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm6.513 10.438l-.1-.224a4.628 4.628 0 00-4.2-2.907H7.855a4.626 4.626 0 00-4.2 2.906l-.107.24a2.558 2.558 0 00.188 2.402A2.092 2.092 0 005.5 17.5h9.117a2.098 2.098 0 001.77-.994 2.57 2.57 0 00.189-2.414zm-1.154 1.784a.966.966 0 01-.803.47h-9.12a.959.959 0 01-.796-.467 1.384 1.384 0 01-.1-1.307l.107-.24a3.49 3.49 0 013.145-2.217h4.42a3.49 3.49 0 013.145 2.219l.1.225a1.4 1.4 0 01-.1 1.317h.002z"
        fill={props.color ?? "#23262F"}
      />
    </svg>
  );
}

export default SvgComponent;
